module.exports = __webpack_public_path__ + "media/dorobek/assets/images/login/logo-human-c7546d26ccfcbf8311e76a017dbe5f37.svg";